// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Luna Point 2
 * Service Luna Point 2
 * Version: v.0.0.0
 */import { NullFilter } from './NullFilter';

export const EmotionFilter = {  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
...NullFilter,} as const
export type EmotionFilter = typeof EmotionFilter[keyof typeof EmotionFilter];
